export default __webpack_public_path__ + "static/media/tag-x.28467bf5.svg";